import { createClient } from "@supabase/supabase-js";
import { Database } from "./types";

const client = createClient<Database>(
    "https://yvlsmugutvabtrpbqkhd.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl2bHNtdWd1dHZhYnRycGJxa2hkIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcxNzI0MzA5NiwiZXhwIjoyMDMyODE5MDk2fQ.Yw6MsrRZDVcitFN0BSgnAs96Ct6J2kTbnPGOgYAZ90g"
);

export default client;
